import clientConfig from '../../clientConfig';
import { ClientConfig } from '../../types';

export function getClientConfig(): ClientConfig {
  return clientConfig;
}
